(function () {
    'use strict';

    angular
        .module('app.alerts')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
             {
                 state: 'alerts',
                 config: {
                     abstract: true,
                     url: '/alerts',
                     template: '<ui-view/>',
                     settings: {
                         authMode: 1,
                         badgeContent: '{{vm.alertsCount}}',
                         requireOps: true
                         
                     },
                     resolve: {
                         authenticationRequired: ['userService', function (userService) {
                             userService.isAuthenticatedThrowError();
                         }]
                     }
                 }
             },
            {
                state: 'alerts.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/alerts/list.html?v=' + opsIncludeVersion,
                    controller: 'AlertsListController',
                    controllerAs: 'vm',
                    title: 'Alerts!',
                    resolve: {
                        isAdmin: ['userService', function (userService) {
                                if (userService.userType() == "0") {
                                    throw { name: "NotAdmin" };
                                }
                            }]
                    }
                }
            },
             {
                 state: 'alerts.details',
                 config: {
                     url: '/detail/:id',
                     templateUrl: 'app/alerts/details.html?v=' + opsIncludeVersion,
                     controller: 'AlertDetailController',
                     controllerAs: 'vm',
                     title: 'Alerts!',
                     params: {fromDisplay:true},
                     settings: {
                     }
                 }
             },
            {
                state: 'alerts.display',
                config: {
                    url: '/display',
                    templateUrl: 'app/alerts/alerts.html?v=' + opsIncludeVersion,
                    controller: 'AlertsController',
                    controllerAs: 'vm',
                    title: 'Alerts!',
                    settings: {
                        nav: 300,
                        content: '<i class="fa fa-bell " data-ng-class="vm.alertsCount > 0 ? \'faa-flash animated\' : \'\'"></i> <span class="leftNavText">Alerts!</span>',
                        badgeContent: '{{vm.alertsCount}}',
                        authMode: 1,
                        requireOps: true,
                        mobileButton: true
                    }
                }
            },
            {
                state: 'alerts.templates',
                config: {
                    url: '/templates',
                    templateUrl: 'app/alerts/templatesList.html?v=' + opsIncludeVersion,
                    controller: 'AlertsTemplatesController',
                    controllerAs: 'vm',
                    title: 'Alert Templates',
                    resolve: {
                        canAccess: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
                state: 'alerts.templatedetails',
                config: {
                    url: '/templatedetails/:uid',
                    templateUrl: 'app/alerts/templatedetails.html?v=' + opsIncludeVersion,
                    controller: 'AlertTemplateDetailController',
                    controllerAs: 'vm',
                    title: 'Alert Template',
                    resolve: {
                        canAccess: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            }
        ];
    }
})();
